import React from 'react';

import {ServerResponseHandler} from 'src/components/server-response-handler';

import {BoxLoading} from '@pb/kit-component-box-loading';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


import {AddSearch} from './add-search';
import {EditSearch} from './edit-search';
import {RemoveSearch} from './remove-search';
import {useGetSearches} from './useGetSearches';

type Props = {
    conferenceId: number,
    readonly?: boolean,
};

export const Searches = ({conferenceId, readonly}: Props) => {
    const {
        isLoading: isSearchesLoading,
        loadingError: searchesLoadingError,
        data: searches,
        loadData: loadSearches,
    } = useGetSearches({conferenceId});

    return (
        <ServerResponseHandler
            sectionName="Searches"
            smallView={true}
            serverError={searchesLoadingError}>
            <FormSection headline="Searches">
                <Group direction="v" alignItems="start">
                    <Item style={{width: 806}}>
                        <BoxLoading loading={isSearchesLoading}>
                            <Table>
                                <Head>
                                    <Cell width={225}>Search Name</Cell>
                                    <Cell>Entity Count</Cell>
                                    <Cell>Search Type</Cell>
                                    <Cell>Actions</Cell>
                                </Head>
                                <Body>
                                    {searches.map(search => (
                                        <Row key={search.id}>
                                            <Cell>
                                                <EllipsisTextHint title={search.name}>
                                                    {search.name}
                                                </EllipsisTextHint>
                                            </Cell>
                                            <Cell>{search.pbIds.length}</Cell>
                                            <Cell>{search.searchSettings}</Cell>
                                            <Cell>
                                                {!readonly && (
                                                    <Group alignItems="center">
                                                        <EditSearch
                                                            searchSettings={search}
                                                            onAdd={loadSearches}
                                                        />
                                                        <RemoveSearch
                                                            searchName={search.name}
                                                            sectionId={search.id}
                                                            onRemove={loadSearches}
                                                        />
                                                    </Group>
                                                )}
                                            </Cell>
                                        </Row>
                                    ))}
                                </Body>
                            </Table>
                        </BoxLoading>
                    </Item>
                    {!readonly && <AddSearch onAdd={loadSearches} conferenceId={conferenceId}/>}
                </Group>
            </FormSection>
        </ServerResponseHandler>
    );
};
